import { createSlice } from "@reduxjs/toolkit";

export const cartSidebarSlice = createSlice({
    name: 'cartSidebar',
    initialState: {
        open: false
    },
    reducers: {
        setCartSidebarOpen: (state, action) => {
            return {
                ...state,
                open: action.payload
            }
        }
    }
})

export const selectCartSidebarOpen = (state) => state.cartSidebar.open;

export const {
    setCartSidebarOpen
} = cartSidebarSlice.actions;

export default cartSidebarSlice.reducer;